import { lazy } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import MasterLayout from "../components/shared-components/MasterLayout";
import SuspensedView from "../components/shared-components/SuspensedView";

const TransferPage = lazy(() => import("../modules/transfers"));
const StatementPage = lazy(() => import("../modules/statements"));
const EventPage = lazy(() => import("../modules/events/EventPage"));
const Error404 = lazy(() => import("../modules/errors/Error404"));
const RedBookPage = lazy(() => import("../modules/redbook"));

const PATHS = [
  { path: "/transfers/*", element: <TransferPage /> },
  { path: "/statements/*", element: <StatementPage /> },
  { path: "/events/*", element: <EventPage /> },
  { path: "/redbook/*", element: <RedBookPage /> },
];

export default function AppRoutes() {
  return (
    <BrowserRouter basename="/">
      <MasterLayout>
        <Routes>
          {PATHS.map(({ path, element }, _index) => (
            <Route key={path} path={path} element={<SuspensedView>{element}</SuspensedView>} />
          ))}
          <Route path="/error/404" element={<Error404 />} />
          <Route path="*" element={<Navigate to="/error/404" />} />
        </Routes>
      </MasterLayout>
    </BrowserRouter>
  );
}
